module.exports = __webpack_public_path__ + "static/media/likeReaction.59a8b728.svg";